import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from '../../css/rulesAndPolicy.module.css'
import Bars from '../Bars';
import { FiArrowLeft } from 'react-icons/fi';

const PrivacyPolicy = () => {
  
  return (

    <>
         
      <NavLink to="/info" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
        <span>Powrót</span>
      </NavLink>

      <div className={` ${styles.rulesAndPolicyConteiner} userSelectNone`}>

        <h3>Polityka prywatności</h3>
        
        <p><strong>1. Administrator danych</strong><br /> Administratorem danych osobowych jest twórca serwisu GórskaPodwózka. Kontakt: mateuszek9119@gmail.com.</p> 

        <p><strong>2. Jakie dane są przetwarzane</strong><br /> Serwis zbiera dane osobowe podane dobrowolnie przez użytkowników podczas dodawania przejazdu lub wyprawy w góry, takie jak: imię, zdjęcie, dane kontaktowe (telefon, Instagram, Messenger) oraz informacje związane z treścią ogłoszenia.</p>

        <p><strong>3. Cel przetwarzania danych</strong><br /> Dane są przetwarzane wyłącznie w celu publikacji ogłoszeń oraz umożliwienia kontaktu pomiędzy użytkownikami serwisu w zakresie organizacji wspólnych przejazdów lub wypraw górskich.</p>

        <p><strong>4. Podstawa prawna</strong><br /> Przetwarzanie odbywa się na podstawie zgody użytkownika (art. 6 ust. 1 lit. a RODO), wyrażonej poprzez dodanie ogłoszenia i zaakceptowanie polityki prywatności.</p>

        <p><strong>5. Zakres udostępniania danych</strong><br /> Dane podane w ogłoszeniu są publicznie dostępne dla odwiedzających serwis, aby umożliwić nawiązanie kontaktu między użytkownikami i każdy odwiedzający może je zobaczyć.</p>

        <p><strong>6. Okres przechowywania danych</strong><br /> Dane związane z ogłoszeniem są przechowywane przez okres niezbędny do realizacji celu, a dzień po terminie rozpoczęcia przejazdu lub wyprawy zostają automatycznie usunięte z serwisu.</p>

        <p><strong>7. Prawa użytkownika</strong><br />
        Użytkownik ma prawo do dostępu do swoich danych, ich poprawienia oraz żądania usunięcia. W przypadku chęci realizacji tych praw proszę o kontakt na adres e-mail podany powyżej. Obecnie nie ma możliwości samodzielnej edycji ani usunięcia danych w serwisie.</p>

        <p><strong>8. Udostępnianie danych</strong><br /> Dane nie są przekazywane podmiotom trzecim poza usługodawcami technicznymi niezbędnymi do działania serwisu (np. hosting, serwery).</p>

        <p><strong>9. Bezpieczeństwo danych</strong><br /> Serwis dba o bezpieczeństwo danych osobowych, stosując odpowiednie środki techniczne i organizacyjne.</p>

        <p><strong>10. Kontakt</strong><br />
        W sprawach dotyczących ochrony danych osobowych proszę o kontakt pod adresem: mateuszek9119@gmail.com.</p>

        <p><strong>11. Dane pogodowe i lokalizacyjne</strong><br />
        Serwis korzysta z zewnętrznych usług dostarczających dane pogodowe oraz geolokalizacyjne (np. API pogodowe), które mogą przetwarzać dane lokalizacyjne miast podanych w ogłoszeniu wyłącznie w celu wyświetlenia informacji o pogodzie. Serwis nie ma wpływu na politykę prywatności tych podmiotów trzecich. Informacje pogodowe prezentowane w serwisie mają charakter poglądowy i nie stanowią gwarancji rzeczywistych warunków atmosferycznych. Użytkownik zobowiązany jest do samodzielnej oceny bezpieczeństwa wyjazdu.</p>

        <p><strong>12. Wyszukiwanie przejazdów w pobliżu</strong><br />
        Serwis umożliwia wyszukiwanie przejazdów w określonym promieniu od wybranego miasta na podstawie współrzędnych geograficznych podanych w ogłoszeniu. Dane te nie są wykorzystywane do śledzenia użytkowników ani profilowania.</p>


        <p><strong>13. Pliki cookies</strong><br />
        Serwis nie wykorzystuje plików cookies w celach marketingowych ani analitycznych.</p>
    
        <p>Dziękujemy za korzystanie z serwisu Górska Podwózka.</p>
       
      </div>

      <p className='mycopyright userSelectNone' >
        © 2025 GórskaPodwózka — wszystkie prawa zastrzeżone. Autor: Mateusz
      </p>

      <Bars />

  </>

  );
};

export default PrivacyPolicy ;
